import { effects } from 'redux-saga'

import {
  makeSelectOffer,
  makeSelectProducts,
} from 'internal-components/src/redux/modules/product/selectors'
import { updateFilter } from '../../modules/signupEdit/actions'

export default function* filterOffers() {
  // For some reason, we've been asked to update the filter
  // for the offer list.

  // This is either: we've arrived at the Offer screen for the first time or
  // that we've selected an offer.
  const state = yield effects.select()

  // 1) If we've got an offer already selected, build a filter for it
  if (state.signupEdit.getIn(['edit', 'offer'])) {
    const offerSelector = yield effects.call(makeSelectOffer)
    const offer = yield effects.call(offerSelector, state, {
      offerId: state.signupEdit.getIn(['edit', 'offer']),
    })

    if (offer) {
      yield effects.put.resolve(updateFilter('productId', offer.product, false))
      yield effects.put.resolve(updateFilter('period', offer.period, false))
      yield effects.put.resolve(updateFilter('speed', offer.speed, false))
      yield effects.put.resolve(
        updateFilter('contract', offer.contractLength, false),
      )
    }

    return
  }

  // 2) Filter offers based on address entry
  const selector = yield effects.call(makeSelectProducts)
  const products = yield effects.call(selector, state, {
    addressSupplied: state.signupEdit.getIn(['edit', 'address']) !== '',
  })

  // 3) Pick the primary product
  const primaryProduct = products.find(product => product.primary)
  if (primaryProduct) {
    yield effects.put.resolve(updateFilter('productId', primaryProduct.id))

    return
  }

  // 4) If one doesnt exist, the first product (if we have products)
  if (products.size) {
    yield effects.put.resolve(updateFilter('productId', products.first().id))
  }
}



// WEBPACK FOOTER //
// ./src/redux/sagas/signupEdit/filterOffers.js